import * as angular from 'angular';
import { config } from 'angular/utils/config';

const { appBaseUrl } = config;

(function () {
    'use strict';

    angular.module('app').controller('MarketInfoCtrl', MarketInfoCtrl);

    function MarketInfoCtrl($routeParams, PAGES, $location) {
        var vm = this;

        vm.goToPage = goToPage;
        vm.isActive = function isActive(path: string) {
            return $location.path().startsWith(path);
        };

        if (angular.isUndefined($routeParams.page)) {
            location.replace(`${appBaseUrl}/market-information/players/tsos`);
            location.reload();
        } else {
            vm.goToPage($routeParams.page);
        }

        /**
         * Change the visible main site content
         *
         * @param {string} goTo
         */
        function goToPage(goTo) {
            switch (goTo) {
                case 'press': {
                    vm.page = PAGES.MARKET_INFO.PRESS;
                    break;
                }
                case 'messages': {
                    vm.page = PAGES.MARKET_INFO.MESSAGES;
                    break;
                }
                case 'message': {
                    vm.page = PAGES.MARKET_INFO.MESSAGE;
                    break;
                }
            }
        }
    }
})();
